import { SortParamValues } from 'src/providers/SortProvider'

import {
  Application_Bool_Exp,
  Application_Order_By,
  Order_By
} from 'src/config/generated/graphql'
import { ParamValue } from 'src/hooks/useFilters'

export function buildListApplicationsWhere({
  filters,
  searchQuery,
  projectId
}: {
  filters?: { [key: string]: ParamValue | null }
  searchQuery?: string
  projectId?: string
}) {
  let where: Application_Bool_Exp = {}

  if (filters?.workflowStates) {
    if (filters.workflowStates !== 'all') {
      where.WorkflowState = {
        _in:
          typeof filters.workflowStates === 'string'
            ? (filters.workflowStates.split(',') as string[])
            : (filters.workflowStates as string[])
      }
    }
  }

  if (filters?.isMatched) {
    where.IsMatched = { _eq: filters.isMatched === 'true' }
  }

  if (filters?.season) {
    where.Season = { Name: { _eq: filters.season as string } }
  }

  if (filters?.regionId) {
    where.RegionId = { _eq: filters.regionId }
  }

  if (filters?.region) {
    where.Region = { Id: { _eq: filters.region } }
  }

  if (filters?.onHoldStatus) {
    const isOnHold = filters.onHoldStatus === 'true'
    where.HoldOnMatch = { _eq: isOnHold }
  }

  if (projectId) {
    where.ProjectId = { _eq: projectId }
  }

  if (searchQuery) {
    const ilikeQuery = `%${searchQuery}%`

    let or: Application_Bool_Exp[] = [
      {
        District: { Name: { _ilike: ilikeQuery } }
      },
      {
        Name: { _ilike: ilikeQuery }
      },
      {
        Planter: { Name: { _ilike: ilikeQuery } }
      },
      {
        Region: { Name: { _ilike: ilikeQuery } }
      },
      {
        Planter: { Account: { Email: { _ilike: ilikeQuery } } }
      },
      {
        Planter: { Account: { Name: { _ilike: ilikeQuery } } }
      }
    ]

    if (Number.isInteger(parseInt(searchQuery))) {
      or = [...or, { Reference: { _eq: Number(searchQuery) } }]
    }

    where = { ...where, _or: or }
  }

  return where
}

export const buildApplicationReference = (
  reference: string,
  name: string,
  userEmail?: string
) => {
  const baseReference = `${reference}: ${name}`
  return userEmail ? `${baseReference} (${userEmail})` : baseReference
}

export function buildListApplicationsOrderBy(sort: SortParamValues) {
  const direction = sort.sortOrder as Order_By
  let orderBy: Application_Order_By = {
    SubmittedAt: 'desc_nulls_last' as Order_By
  }
  if (!sort.sortColumn) return orderBy

  if (sort.sortColumn === 'Project') {
    orderBy = { Project: { Name: direction } }
  } else if (sort.sortColumn === 'Region') {
    orderBy = { Region: { Name: direction } }
  } else if (sort.sortColumn === 'Planter') {
    orderBy = { Planter: { Name: direction } }
  } else if (sort.sortColumn === 'Season') {
    orderBy = { Season: { Name: direction } }
  } else {
    orderBy = { [sort.sortColumn!]: direction }
  }

  return orderBy
}
